import { LoadingValueWrapperImpl } from "@glide/computation-model-types";

export function makeLoadingValueWrapper() {
    return new LoadingValueWrapperImpl();
}
